import moment from 'moment'
import { AsyncAction } from '~/redux/types'

import { ActionTypes, Actions, Payment } from './types'

export const reset = (): Actions => ({
	type: ActionTypes.RESET
})

export const paymentsAsync =
	(year: number, month: number): AsyncAction<void> =>
	async (dispatch, getState, { payments }) => {
		dispatch({ type: ActionTypes.LOAD_START })
		try {
			const payload = await payments.get(year, month)

			dispatch({
				type: ActionTypes.LOAD_SUCCESS,
				payload: payload.reduce<{ [date: string]: Payment }>(
					(agg, payment) => ({
						...agg,
						[moment.utc(payment.day).format()]: payment
					}),
					{}
				)
			})
		} catch (error) {
			dispatch({ type: ActionTypes.LOAD_FAIL, error })
		}
	}
